import { Flex, Separator } from '@buffer-mono/popcorn'
import { useSplitEnabled } from '@buffer-mono/features'

import { NewSettingsPageLayout } from './components/NewSettingsPageLayout'
import Delete from './ProfileSettings/DeleteAccount'
import Email, { EmailVerificationBanner } from './ProfileSettings/Email'
import Name from './ProfileSettings/Name'
import Password from './ProfileSettings/Password'
import Photo from './ProfileSettings/Photo'
import TwoFactor from './ProfileSettings/TwoFactor'
import BackupEmail from './ProfileSettings/BackupEmail'
const ProfileSettings = (): JSX.Element => {
  const { isEnabled } = useSplitEnabled('backup-email')
  return (
    <NewSettingsPageLayout title="Profile">
      <Flex gap="lg" direction="column" fullWidth>
        <EmailVerificationBanner />
        <Photo />
        <Name />
        <Email />
        {isEnabled && <BackupEmail />}
        <Password />
      </Flex>
      <Separator />
      <TwoFactor />
      <Separator />
      <Delete />
    </NewSettingsPageLayout>
  )
}

export default ProfileSettings
